import React from "react";
import PropTypes from "prop-types";

function InvalidFeedback(props) {
  const { errors, label } = props;

  return errors != null && (
    <div className='invalid-feedback'>
      {errors.map((value) => (label === null ? value : label + value)).join(", ")}
    </div>
  );
}

InvalidFeedback.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string
};

InvalidFeedback.defaultProps = {
  errors: null,
  label: null
};

export default InvalidFeedback;
